import { Component, OnInit, OnDestroy } from "@angular/core";
import { AuthAccessProvider } from "../core/core.auth";
import { Router } from "@angular/router";
import {
  UserContext,
  BaseComponent,
  User,
  Scrivania,
} from "../core/core.component";
import { MessageProvider } from "../service/message.service";
import { DeskManagementService } from "../service/manageDesk.service";
import { Subscription } from "rxjs/Subscription";
import { SelectItem } from "primeng/primeng";

declare var $: any;

@Component({
  selector: "app-manage-desk",
  templateUrl: "./manage-desk.component.html",
  styleUrls: ["./manage-desk.component.css"],
})
export class ManageDeskComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  static ASSIGN_DIALOG_ID: string = "AssignDeskDialog";
  static REMOVE_DIALOG_ID: string = "RemoveDeskDialog";
  private subscriptions: Subscription[] = [];
  loading: boolean = false;

  userContext: UserContext = null;
  user: User = null;
  userDesks: Scrivania[] = null;

  desks: SelectItem[] = [];
  selectedDesk: Scrivania = null;
  errorMessage: string = null;

  constructor(
    protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private deskManagementService: DeskManagementService
  ) {
    super(authAccess, router, messageProvider);
  }

  ngOnDestroy() {
    if (this.subscriptions != null) {
      for (let i = 0; i < this.subscriptions.length; ++i) {
        this.subscriptions[i].unsubscribe();
      }
    }
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.subscriptions[0] = this.deskManagementService
        .getManageDeskComponentStatus()
        .subscribe((userData) => {
          if (userData.user != null) {
            this.user = userData.user;
            this.userDesks = userData.desks;
            if (userData.desks.length > 0) {
              $("#" + ManageDeskComponent.REMOVE_DIALOG_ID).modal({
                backdrop: "static",
                keyboard: false,
              });
            } else {
              $("#" + ManageDeskComponent.ASSIGN_DIALOG_ID).modal({
                backdrop: "static",
                keyboard: false,
              });
              this.loadDesks();
            }
          }
        });
    }
  }

  private loadDesks() {
    this.errorMessage = null;
    this.loading = true;
    this.deskManagementService.getDesks(this.userContext.srmToken).subscribe(
      (result) => {
        this.desks = [];
        result.listScrivanie.forEach((desk : Scrivania) => {
          this.desks.push({
            label: desk.idScrivania + " - " + desk.nome,
            value: desk,
          });
        });
        this.loading = false;
      },
      (error) => {
        this.errorMessage = this.retrieveError(error);
        this.loading = false;
      }
    );
  }

  assignDeskToUser() {
    if (this.selectedDesk) {
      this.deskManagementService
        .assignDesk(
          this.userContext.srmToken,
          this.selectedDesk.idScrivania,
          this.user.id,
          this.generateDeskName()
        )
        .subscribe(
          () => {
            this.closeAssign();
          },
          (error) => {
            this.errorMessage = this.retrieveError(error);
          }
        );
    }
  }

  removeDeskToUser() {
    this.deskManagementService
      .removeDesk(this.userContext.srmToken, this.userDesks[0].idScrivania, this.user.id)
      .subscribe(
        () => {
          this.closeRemove();
        },
        (error) => {
          this.errorMessage = this.retrieveError(error);
        }
      );
  }

  generateDeskName(): String {
    var fullnameParts = this.user.fullname.split(" ");
    var name = "Scrivania";
    fullnameParts.forEach((namePart, index) => {
      if (index == fullnameParts.length - 1) {
        name += " " + namePart[0] + ".";
      } else {
        name += " " + namePart;
      }
    });
    return name;
  }

  closeAssign() {
    $("#" + ManageDeskComponent.ASSIGN_DIALOG_ID).modal("hide");
    this.user = null;
    this.userDesks = null;
    this.selectedDesk = null;
    this.errorMessage = null;
  }

  closeRemove() {
    $("#" + ManageDeskComponent.REMOVE_DIALOG_ID).modal("hide");
    this.user = null;
    this.userDesks = null;
    this.selectedDesk = null;
    this.errorMessage = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/manage-desk/manage-desk.component.ts